import PropTypes from 'prop-types';

import providerGeneric from './providerGeneric';

export default {
  ...providerGeneric,
  logo2xWhite: PropTypes.string,
};
